/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import { UFOExperienceState, UFOExperience, ConcurrentExperience, AbstractExperienceConfig, EndStateConfig, perfNowOrTimestamp, ExperienceTypes, ExperiencePerformanceTypes, GlobalPageLoadExperience } from '@atlassian/ufo-experimental/platform-client'` instead.
 */
export {
	UFOExperienceState,
	UFOExperience,
	ConcurrentExperience,
	type AbstractExperienceConfig,
	type EndStateConfig,
	perfNowOrTimestamp,
	ExperienceTypes,
	ExperiencePerformanceTypes,
	GlobalPageLoadExperience,
} from './platform-client';

/**
 * @deprecated Use `import { ufolog, ufologger, ufowarn } from '@atlassian/ufo-experimental/logger'` instead.
 */
export { ufologger } from './logger';
export { ufolog } from './logger/ufolog';
/**
 * @deprecated Use `import { ufowarn } from '@atlassian/ufo-experimental'` instead.
 */
export { ufowarn } from './logger/ufowarn';

/**
 * @deprecated Use `import { getGlobalEventStream, setGlobalEventStream, experiencePayloadEvent, unsubscribeEvent, subscribeEvent } from '@atlassian/ufo-experimental/global-stream-buffer'` instead.
 */
export { experiencePayloadEvent } from './global-stream-buffer/experiencePayloadEvent';
export { getGlobalEventStream } from './global-stream-buffer/getGlobalEventStream';
/**
 * @deprecated Use `import { setGlobalEventStream } from '@atlassian/ufo-experimental'` instead.
 */
export { setGlobalEventStream } from './global-stream-buffer/setGlobalEventStream';
/**
 * @deprecated Use `import { subscribeEvent } from '@atlassian/ufo-experimental'` instead.
 */
export { subscribeEvent } from './global-stream-buffer/subscribeEvent';
/**
 * @deprecated Use `import { unsubscribeEvent } from '@atlassian/ufo-experimental'` instead.
 */
export { unsubscribeEvent } from './global-stream-buffer/unsubscribeEvent';

/**
 * @deprecated Use `import type { CustomData } from '@atlassian/ufo-experimental/types'` instead.
 */
export type { CustomData } from './types';

/**
 * @deprecated Use `import { UFO_EXPERIMENTAL_BUILD_VERSION } from '@atlassian/ufo-experimental/build-version'` instead.
 */
export { UFO_EXPERIMENTAL_BUILD_VERSION } from './buildVersion';

/**
 * @deprecated Use `import { visibilityChangeObserver } from '@atlassian/ufo-experimental/visibility-change-observer'` instead.
 */
export { visibilityChangeObserver } from './observer/visibility-change-observer';

/**
 * @deprecated Use `import { untilAll } from '@atlassian/ufo-experimental/until-helpers'` instead.
 */
export { untilAll } from './platform-client/utils/until-helpers';

/**
 * @deprecated Use `import { useUFOExperience } from '@atlassian/ufo-experimental/use-ufo-experience'` instead.
 */
export { useUFOExperience } from './platform-client/hooks/useUFOExperience';
/**
 * @deprecated Use `import { useUFOStreamingExperience } from '@atlassian/ufo-experimental/use-ufo-streaming-experience'` instead.
 */
export { useUFOStreamingExperience } from './platform-client/hooks/useUFOStreamingExperience';
